import { c as _c } from "react/compiler-runtime";
import JobCard from "@components/JobCard";
import Section from "@components/Section";
import { Title } from "@justhome/react-ui";
import { ComponentSectionsOpenJobs, Job } from "@lib/generated/graphql";
import { FC } from "react";
const OpenJobsComponent: FC<{
  data: ComponentSectionsOpenJobs;
  jobs: Job[];
}> = t0 => {
  const $ = _c(10);
  const {
    data,
    jobs
  } = t0;
  let t1;
  if ($[0] !== data.title) {
    t1 = <Title>{data.title}</Title>;
    $[0] = data.title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== jobs) {
    t2 = jobs.map(_temp);
    $[2] = jobs;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <div className="grid grid-cols-1 m:grid-cols-2 l:grid-cols-3 gap">{t2}</div>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== data || $[7] !== t1 || $[8] !== t3) {
    t4 = <Section section={data} className="flex flex-col gap-m m:gap-xl py-2m m:py-5xl">{t1}{t3}</Section>;
    $[6] = data;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default OpenJobsComponent;
function _temp(jobCard, index) {
  return <JobCard key={index} title={jobCard.title} slug={jobCard.slug} employmentType={jobCard.employmentType} location={jobCard.location} category={jobCard.category} backgroundColor={jobCard.employmentTypeBackground} />;
}